import { queryKeys } from '@/react-query/constants';
import { createQueryKeys } from '@/shared/api';

export const searchKeys = createQueryKeys(queryKeys.search);
